export default function (context, val) {
  context.state.form.AgreementCodes.forEach(code => {
    context.dispatch('agreements/set_comment', context.getters['agreements/agreement'](code));
  });
}